import { $elementChild, $elementChildren } from "@grindex-common/helpers/elements";
import { addListener, getDatasetItemBoolean } from "@grindex-common/helpers/domManipulation";
import { SpecTable } from "./classes/SpecTable.class";
import { events } from "@grindex-common/helpers/events";
import TabNames from "@grindex-client/components/Tabs/TabNames.class";
import asyncModule from "@grindex-client/components/Module/asyncModule";
import { isNullish } from "@client/common/js/helpers/typeHelpers";
import { underscoreTemplateGrindex } from "@grindex-client/common/js/helpers/underscore-helper";

(function listenForEvent() {
	asyncModule("techSpecTable", events.tabLoadedEvent(new TabNames().product.technicalSpecifications), init);
})();

const event = new Event("tab:loaded_specifications");
window.dispatchEvent(event);

function init($module) {
	const $toggleButtons = $module.parentElement.querySelectorAll(".btnHolder");

	const $tableSource = $elementChild($module, "table-source")?.value;
	const includeFilters = getDatasetItemBoolean($module, "includeFilters");

	if (isNullish($tableSource)) {
		return;
	}

	const tableData = JSON.parse($tableSource);

	const tables = [];

	if (tableData) {
		const typeOfTable = includeFilters ? "#table-template-with-filters" : "#table-template";
		const $tableTemplateInnerHTML = document.querySelector(typeOfTable).innerHTML;

		const $tableTemplate = underscoreTemplateGrindex($tableTemplateInnerHTML);

		for (const table of tableData) {
			$module.innerHTML += $tableTemplate(table);
		}
	}

	for (const $toggleButton of $toggleButtons) {
		addListener($toggleButton, "toggle:changed", applyToggleFilters);
		applyToggleFilters($toggleButton);
	}

	function applyToggleFilters(evt) {
		const $button = evt.currentTarget || evt;
		const data = $button.dataset;
		const $tabModule = $button.closest(".tab-content");
		let showSelector = "";

		$tabModule.querySelectorAll(".btnHolder").forEach(($toggleButton) => {
			const buttonData = $toggleButton.dataset;
			const showValue = buttonData[buttonData.isOn === "true" ? "on" : "off"];
			showSelector += `[data-filter-${buttonData.filter}="${showValue}"]`;
		});

		$tabModule.querySelectorAll(`[data-filter-${data.filter}]`).forEach(($filter) => {
			$filter.classList.add("hidden");
			$filter.parentElement.classList.add("hidden");
		});

		$tabModule.querySelectorAll(showSelector).forEach(($filter) => {
			$filter.classList.remove("hidden");
			$filter.parentElement.classList.remove("hidden");
		});
	}

	const $tableModules = $elementChildren($module, "technical-specification-table");

	for (const $view of $tableModules) {
		tables.push(new SpecTable($view));
	}
}

export default {
	view: "techSpecTable",
	init,
};
